import ttModulesList from "../config/modules/ttModulesList";
import moduleAccessHelper from "./moduleAccessHelper";
import permissionHelper from "./permissionHelper";
import { UserContextInterface } from "../state/UserContext";

const selfServeNotificationsAccessHelper = {
  userHasSelfServeNotificationsModule(userContext: UserContextInterface): boolean {
    return moduleAccessHelper.userHasModule(
      userContext.user,
      ttModulesList.SelfServeNotifications,
    );
  },

  userCanAccessSelfServeNotifications(userContext: UserContextInterface): boolean {
    const hasPermission =
      userContext.user.client.permissionMode === "LEGACY-PERMISSIONS"
        ? permissionHelper.userHasPermission(userContext, "ManageNotifications")
        : permissionHelper.userHasPermission(userContext, "MANAGE-NOTIFICATIONS");

    return (
      hasPermission &&
      selfServeNotificationsAccessHelper.userHasSelfServeNotificationsModule(
        userContext,
      )
    );
  },
};

export default selfServeNotificationsAccessHelper;
